export default {"src":"https://fishbrain.com/_next/static/media/michigan.f1705e90.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};